import React, { useEffect, useState } from "react";
import {
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import KYS2FormApprovalTab from "./KYS2FormApprovalTab";
import KYS2FormPendingListTab from "./KYS2FormPendingListTab";
import { API } from "../../../../../../config/constants";
import axiosHelper from "../../../../../../axiosHelper";
import { apiErrors, notify } from "../../../../../../helper";
import KYS2FormRequestReviewTab from "./KYS2FormRequestReviewTab";

const KysTwoApproval = ({viewDataFromSupplier}) => {
    const [activeTab, setActiveTab] = useState("1");
    const [reviewRequestResponseData, setReviewRequestResponseData] = useState(null);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            getKYS2RequestReviewResponse(id)
        }
    }, [])

    const getKYS2RequestReviewResponse = (id) => {
        axiosHelper.get(`${API.getKYS2RequestReviewResponse}?VendorRequirementRegistrationId=${id}`)
            .then((response) => {
                if (response?.data?.IsSuccessful) {
                    setReviewRequestResponseData(response?.data?.Data);
                }

            }).catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                  }else{
                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage);
                    }
                  }
              
                // apiErrors(error);
                // throw error; // Re-throw the error to the caller
            });
    }

    return (
        <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
            <div className="hl-approval-tabs">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                                toggle("1");
                            }}
                        >
                            Approval
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                                toggle("2");
                            }}
                        >
                            Pending List
                        </NavLink>
                    </NavItem>
                    {
                        reviewRequestResponseData && reviewRequestResponseData?.RequestReviews?.length > 0 && (
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "3" })}
                                    onClick={() => {
                                        toggle("3");
                                    }}
                                >
                                    {`Request Review (${reviewRequestResponseData?.RequestReviewCount})`} 

                                </NavLink>
                            </NavItem>
                        )
                    }
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Row className="ag-grid-react custom-pagination without-filter-grid">
                            <KYS2FormApprovalTab />
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <KYS2FormPendingListTab />
                        </Row>
                    </TabPane>
                    {
                        reviewRequestResponseData && reviewRequestResponseData?.RequestReviews?.length > 0 && (
                            <TabPane tabId="3">
                                <Row>
                                    <KYS2FormRequestReviewTab reviewRequestResponseData={reviewRequestResponseData} viewDataFromSupplier={viewDataFromSupplier} />
                                </Row>
                            </TabPane>
                        )
                    }
                    <TabPane tabId="4">
                        <Row>
                            <Col sm="12">
                                <h4>Tab 4 Contents</h4>
                                <p>Here is where you can add content for Tab 4.</p>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </div>

        </div>
    );
};

export default KysTwoApproval;
